package org.zest.insan_360_website.model

import kotlinx.serialization.Serializable

@Serializable
enum class ApiErrorCode(val statusCode: Int) {
    // --- 1. AUTHENTICATION (401 - "Who are you?") ---
    INVALID_CREDENTIALS(401),
    MISSING_REFRESH_TOKEN(401),
    INVALID_REFRESH_TOKEN(401),
    INVALID_TOKEN(401),
    TOKEN_VERIFICATION_FAILED(401),
    INVALID_RESET_TOKEN(400),
    RESET_TOKEN_EXPIRED(410),

    // --- 2. AUTHORIZATION (403 - "I know who you are, but you're not allowed") ---
    EMAIL_NOT_VERIFIED(403),
    MUST_REGISTER_AS_STUDENT(403),
    UNAUTHORIZED_ROLE_ACCESS(403),
    USER_ROLE_NOT_VALIDATED(403),
    UNAUTHORIZED_ACTION(403),

    // --- 3. NOT FOUND (404) ---
    USER_NOT_FOUND(404),
    ORGANIZATION_NOT_FOUND(404),
    ORG_NAME_MISSING(404),
    SUPER_ADMIN_NOT_FOUND(404),
    NO_IN_PROGRESS_CREDIT(404),

    // --- 4. MALFORMED REQUESTS / VALIDATION (400 - "You sent bad data") ---
    MISSING_REQUEST_BODY(400),
    INVALID_JSON_STRUCTURE(400),
    UNKNOWN_ROLE_TYPE(400),
    MISSING_PAYLOAD_BODY(400),
    MALFORMED_PAYLOAD(400),
    ORG_NAME_REQUIRED(400),
    MISSING_VERIFICATION_TOKEN(400),
    INVALID_VERIFICATION_LINK(400),
    MISSING_EMAIL_PARAMETER(400),
    MISSING_BILL_CODE_PARAMETER(400),
    ORG_UPDATE_FAILED(400),

    // --- 5. SYSTEM ERRORS (405, 500) ---
    METHOD_NOT_ALLOWED(405),
    INTERNAL_SERVER_ERROR(500),
    ACTION_FAILED(500),
    DATA_INTEGRITY_MISMATCH(500),
    MULTIPLE_ROWS_UPDATED(500),

    // --- 6. ASSESSMENTS & REPORTS (Domain Specific) ---
    TEST_NOT_FOUND(404),
    TEST_RECORDS_NOT_FOUND(404),
    SUBMITTER_NOT_FOUND(404),
    REPORT_NOT_FOUND(404),
    FILE_MISSING_FROM_STORAGE(404),
    REPORT_EXPIRED(410),
    REPORT_ALREADY_REQUESTED(409),
    PENDING_TEST_EXISTS(409),
    TEST_ALREADY_PROCESSED(409),
    TEST_ALREADY_VERIFIED(403),
    TEST_NOT_VERIFIED(422),
    TEMPLATE_NOT_SELECTED(400),
    INVALID_TEMPLATE_PATH(403),
    TEMPLATE_NOT_FOUND(404),
    INVALID_UUID_FORMAT(400),
    INVALID_IMAGE_ENCODING(400),

    // --- 7. ADMIN VERIFICATION & INVITES (Domain Specific) ---
    ADMIN_ALREADY_VERIFIED(403),
    VERIFICATION_UPDATE_FAILED(409),
    USER_ALREADY_AFFILIATED(403),
    INVITE_ROLE_RESTRICTION(403),
    INVITE_ALREADY_SENT(409),
    CANNOT_INVITE_SELF(403),

    // --- 8. CREDITS & SESSIONS (Domain Specific) ---
    INVALID_CREDIT_COUNT(400),
    SUPER_ADMIN_CREDIT_RESTRICTION(403),
    STUDENT_CREDIT_LIMIT_REACHED(403),
    UNFULFILLED_CREDIT_EXISTS(409),
    STUDENT_NOT_AFFILIATED(403),
    STUDENT_HAS_PENDING_TEST(409),
    STUDENT_ALREADY_ASSIGNED_CREDIT(409),
    STUDENT_HAS_PERSONAL_CREDIT(409),
    NO_AVAILABLE_CREDIT(422),
    NO_ACTIVE_CREDIT(422),
    NO_ELIGIBLE_CREDIT_FOUND(422),
    CREDIT_ASSIGNMENT_CONFLICT(409),
    UNAUTHORIZED_CREDIT_ACCESS(403),
    INVALID_STATUS_TRANSITION(400),
    MUST_RESOLVE_PENDING_TEST(422),
    CREDIT_STATUS_CONCURRENT_MODIFICATION(409),
    CREDIT_ALREADY_CONSUMED(409),
    MAX_EXTENSION_COUNT_EXCEEDED(403),
    CREDIT_SESSION_EXPIRED(403),
    SESSION_CONCURRENTLY_EXTENDED(409),

    // --- 9. PAYMENTS / TOYYIBPAY (Domain Specific) ---
    EMAIL_ALREADY_EXISTS(409),
    AFFILIATED_STUDENT_CANNOT_PURCHASE(403),
    MAX_ACTIVE_CREDIT_REACHED(403),
    COOLDOWN_PERIOD_ACTIVE(403),
    ADMIN_COOLDOWN_ACTIVE(403),
    TOYYIBPAY_BILL_CREATION_FAILED(500),
    TOYYIBPAY_PAYLOAD_REJECTED(400),
    TOYYIBPAY_MISSING_BILLCODE(500),
    TOYYIBPAY_NETWORK_ERROR(500),

    // --- 10. MAINTENANCE ---
    MAINTENANCE_MODE(503),

    // --- 11. RATE LIMITING ---
    RATE_LIMIT_EXCEEDED(429),
    ACCOUNT_LOCKED(423)
}

@Serializable
enum class ApiSuccessCode {
    ACCOUNT_CREATED,
    LOGIN_SUCCESSFUL,
    LOGOUT_SUCCESSFUL,
    PASSWORD_RESET_EMAIL_SENT,
    PASSWORD_RESET_SUCCESSFUL,
    STATS_LOADED_SUCCESSFULLY,
    CREDIT_GRANTED_SUCCESSFULLY,
    TEST_USERS_LOADED_SUCCESSFULLY,
    USER_INFO_LOADED_SUCCESSFULLY,
    ADMINS_INFO_LOADED_SUCCESSFULLY,
    ADMIN_VERIFIED_SUCCESSFULLY,
    TEMPLATES_LOADED_SUCCESSFULLY,
    REPORT_GENERATED_SUCCESSFULLY,
    CREDIT_STATS_LOADED_SUCCESSFULLY,
    INVITES_LOADED_SUCCESSFULLY,
    STUDENTS_LOADED_SUCCESSFULLY,
    INVITE_SENT_SUCCESSFULLY,
    CREDIT_ASSIGNED_SUCCESSFULLY,
    CREDIT_STATUS_FETCHED_SUCCESSFULLY,
    CREDIT_HISTORY_FETCHED_SUCCESSFULLY,
    CREDIT_STATUS_UPDATED_SUCCESSFULLY,
    CREDIT_SESSION_FETCHED_SUCCESSFULLY,
    CREDIT_SESSION_EXTENDED_SUCCESSFULLY,
    TEST_SUBMITTED_SUCCESSFULLY,
    TEST_REJECTED_SUCCESSFULLY,
    TEST_STATUS_LOADED,
    SUBMISSION_HISTORY_LOADED,
    PAYMENTS_LOADED_SUCCESSFULLY,
    MAINTENANCE_STATUS_FETCHED,
    MAINTENANCE_STATUS_UPDATED,
    REPORT_REQUESTED_SUCCESSFULLY,
    GENERAL_SUCCESS
}